import type { Resource } from '../../';
export const header_utilBar_guaranteeLink: Resource = {"default":"Free Shipping & Free Returns"};
